var map = {
	"./r1.jpg": 2994,
	"./r2.jpg": 745,
	"./r3.jpg": 4857,
	"./r4.jpg": 1606,
	"./r5.jpg": 1398,
	"./r6.jpg": 1994,
	"./r7.jpg": 8935,
	"./r8.jpg": 5946,
	"./r9.jpg": 671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9852;